<template>
  <div>
    <custom-dialog width="60%" :title="model.title" :visible="visible" v-on="$listeners">
      <div class="dialog-body" style="padding-top: 0">
        <div class="search-hd">
          <el-form :inline="true" @submit.native.prevent>
            <!-- 操作项 -->
            <el-form-item>
              <el-button v-if="selectRow.createMode === 2" type="primary" icon="el-icon-plus" @click="bindDevice()">{{$t('dms_bind_device_dialog.bang_ding_she_bei')}} </el-button>
            </el-form-item>
            <!-- 搜索栏 -->
            <el-form-item style="float: right">
              <search-input
                v-model="formSearch.search"
                :placeholder="$t('dms_bind_device_dialog.ji_shen_haoModemSN')"
                @fetch="getTableList()"
              ></search-input>
            </el-form-item>
          </el-form>
        </div>
        <div class="table-bd">
          <custom-table
            :data="tableList"
            :column="tableColumn"
            @filter="filterChange"
            @sort="sortChange"
          >
            <el-table-column
              :label="$t('Common.com_handle')"
              fixed="right"
              min-width="120"
              v-if="tableColumn.length && selectRow.createMode === 2"
            >
              <template slot-scope="scope">
                <el-button type="text" size="mini" @click="deleteDevice(scope.row)">{{$t('Common.com_remove')}}</el-button>
              </template>
            </el-table-column>
          </custom-table>
        </div>
      </div>
      <div slot="footer" class="dialog-footer">
        <el-button size="small" @click="visible = false">{{$t('Common.com_close')}}</el-button>
      </div>
    </custom-dialog>
    <!-- 关联设备 -->
    <bind-select-dialog
      v-if="dialogVisible"
      :model="dialogModel"
      @close="dialogVisible = false"
      @success="getTableList()"
    ></bind-select-dialog>
  </div>
</template>

<script>
import apis from '@/utils/apis';
import dialogMixins from '@/mixins/dialog_mixins';
import bindSelectDialog from './bind_select_dialog.vue';

export default {
  mixins: [dialogMixins],
  components: { bindSelectDialog },
  // props: {
  //   data: [String, Object, Array],
  //   model: {
  //     type: Object,
  //     default() {
  //       return {};
  //     },
  //   },
  // },
  data() {
    return {
      tableCode: 'siteBindDevice',
      formSearch: {
        search: '',
        siteId: '',
      },
      tableList: [],

      dialogVisible: false,
      dialogModel: {},

      // visible: true,
      selectRow: {},
    };
  },
  mounted() {
    this.getTableColumn();
    this.initDialog();
  },
  methods: {
    // 初始化
    initDialog: function () {
      this.selectRow = this.model.row;
      this.$setFormatData(this.formSearch, this.model.row);
      this.getTableList();
    },
    // 获取表格数据
    getTableList: function () {
      this.$getJSON(apis.SiteAssList, this.formSearch).then((res) => {
        this.tableList = res.data;
      });
    },
    // 关联设备
    bindDevice: function () {
      this.dialogModel = { title: this.$t('dms_bind_device_dialog.bang_ding_she_bei'), data: this.selectRow };
      this.dialogVisible = true;
    },
    // 删除设备
    deleteDevice: function (row) {
      this.$showConfirm(this.$t('dms_bind_device_dialog.nqdyycxzdsbm')).then(() => {
        this.$postJSON(`${apis.SiteCancelBind}/${row.modemSn}`).then(() => {
          this.$message({
            message: this.$t('Common.com_handle_success'),
            type: 'success',
          });
          this.getTableList();
        });
      }).catch(() => {});
    },
  },
};
</script>

<style lang="scss">
</style>
